document.addEventListener("DOMContentLoaded", function() {
	// store tabs variable
	var currentTab = $('.tab-pane.active');
	var myTabs = document.querySelectorAll("ul.nav-tabs > li");
  function myTabClicks(tabClickEvent) {
		var clickedTab = tabClickEvent.currentTarget;
		if(currentTab.attr('id') === 'tab-1') {
			if($('.radio-group--size:checked').length === 0) {
				$("#tab-1 .widget-body-inner__options h2").shake();
				return;
			}
		}
		else if(currentTab.attr('id') === 'tab-2') {
			console.log("Tab:", clickedTab);
			console.log($(clickedTab).find('a').attr('id'));
			if($(clickedTab).find('a').attr('href') === '#tab-3') {
				var uploadLink = getUploadLink();
				if(uploadLink === undefined || uploadLink.length === 0) {
						$(".widget-container.open #tab-2 .widget-body__image-upload").shake();		
					return;
				}
			}
		}
		for (var i = 0; i < myTabs.length; i++) {
			myTabs[i].classList.remove("active");
		}
		clickedTab.classList.add("active");
		tabClickEvent.preventDefault();
		var myContentPanes = document.querySelectorAll(".tab-pane");
		for (i = 0; i < myContentPanes.length; i++) {
			myContentPanes[i].classList.remove("active");
		}
		var anchorReference = tabClickEvent.target;
		console.log("Target:", tabClickEvent.target.nodeName);
		if(tabClickEvent.target.nodeName === 'LI') {
			anchorReference = tabClickEvent.target.querySelector('a');
		}
		var activePaneId = anchorReference.getAttribute("href");
		var activePane = anchorReference.closest('.widget-container').querySelector(activePaneId);
		activePane.classList.add("active");
		if(activePaneId === "#tab-2") {
			window.dispatchEvent(new Event('resize'));
			setTimeout(function(){
				$('.canvas-container').css('opacity', 1);
			}, 300)
		}
		updateFooterButton(activePaneId);
		currentTab =  $('.tab-pane.active');
	}
	for (i = 0; i < myTabs.length; i++) {
		myTabs[i].addEventListener("click", myTabClicks)
	}
});


function updateFooterButton(paneId) {
	let selectedIndex = paneId.split('-')[1];
	let buttons = $('.widget-footer__actions button');
	buttons.each(function(_i, button) {
		let buttonIndex = $(button).attr('data-index');
		if(buttonIndex === selectedIndex) {
			$(button).show();
		}
		else {
			$(button).hide();
		}
	});
}

jQuery.fn.shake = function(interval,distance,times){
   interval = typeof interval == "undefined" ? 100 : interval;
   distance = typeof distance == "undefined" ? 10 : distance;
   times = typeof times == "undefined" ? 3 : times;
   var jTarget = $(this);
   jTarget.css('position','relative');
   for(var iter=0;iter<(times+1);iter++){
      jTarget.animate({ left: ((iter%2==0 ? distance : distance*-1))}, interval);
   }
   return jTarget.animate({ left: 0},interval);
}